import { z } from 'zod';
export const serviceAccountRefSchema = z.object({
    id: z.string(),
    serviceAccount: z.object({
        id: z.string(),
        name: z.string(),
    }),
});
